document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mp-root]').forEach((root) => {
    root.querySelectorAll('[data-mp-tabs] button').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-mp-tabs] button').forEach((item) => {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        root.querySelectorAll('[data-mp-links]').forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.mpLinks === button.dataset.target);
        });
      });
    });

    const slides = [...root.querySelectorAll('.mp-slide')];
    const dots = [...root.querySelectorAll('.mp-dot')];
    let slideIndex = 0;
    const showSlide = (index) => {
      if (!slides.length) return;
      slideIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === slideIndex));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === slideIndex));
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => showSlide(slideIndex - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => showSlide(slideIndex + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => showSlide(i)));

    let selectedStatus = '';
    const filterMaterials = () => {
      const brand = (root.querySelector('[data-brand]')?.value || '').toLowerCase();
      const type = (root.querySelector('[data-type]')?.value || '').toLowerCase();
      const term = (root.querySelector('[data-material-search]')?.value || '').toLowerCase();
      root.querySelectorAll('[data-material]').forEach((card) => {
        const visible = card.dataset.brand.includes(brand)
          && card.dataset.type.includes(type)
          && card.dataset.status.includes(selectedStatus)
          && card.textContent.toLowerCase().includes(term);
        card.classList.toggle('mp-hidden', !visible);
      });
    };

    root.querySelectorAll('[data-material-filter]').forEach((field) => {
      field.addEventListener(field.matches('input') ? 'input' : 'change', filterMaterials);
    });
    root.querySelectorAll('[data-status]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedStatus = button.dataset.status || '';
        root.querySelectorAll('[data-status]').forEach((item) => item.classList.toggle('is-active', item === button));
        filterMaterials();
      });
    });
  });
});
